import { handleEvent } from '../../helpers';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class {
  constructor(el) {
    this.el = el;
    this.scrollPosition = 0;
    this.body = document.querySelector('body');
    this.activeElem;
  }

  init() {
    this.handleEvents();
  }

  handleEvents() {
    this.ClosePopup = handleEvent('keydown', {
      el: this.body,
      preventDefault: false,
      stopPropagation: false,
      callback: this.closePopupTarget.bind(this)
    });

    this.openPopup = handleEvent('click', {
      el: this.body,
      preventDefault: false,
      stopPropagation: false,
      callback: this.popupOpen.bind(this)
    });

// console.log(this.activeElem.querySelector('.close-popup svg'))

    this.closePopupClick = handleEvent('click', {
      el: document.querySelector('.popup-inner'),
      preventDefault: false,
      stopPropagation: false,
      callback: this.closePopupSvg.bind(this)
    });
  }

  popupOpen(e) {
    if (!e.target.closest('.popup-txt') && document.querySelector('html').classList.contains('active-scroll')) {
      document.querySelector('html').classList.remove('active-scroll');
      this.activeElem.classList.remove('--active');
      enableBodyScroll(document.body);
    }

    if (e.target.closest('button') && e.target.closest('button').dataset.personal != '' && e.target.closest('button').dataset.personal != undefined) {
      let targetElem = e.target.closest('button').dataset.personal;

      this.activeElem = document.querySelector(`.popup-txt[data-personal="${targetElem}"]`);
      this.activeElem.classList.add('--active');
      document.querySelector('html').classList.add('active-scroll');
      disableBodyScroll(document.body);
    }
  }

  closePopupTarget(e) {
    if (event.keyCode === 27) {
      document.querySelector('html').classList.remove('active-scroll');
      this.activeElem.classList.remove('--active');

      enableBodyScroll(document.body);
    }
  }

  closePopupSvg(e) {
    if(e.target.closest('.close-popup') || e.target === document.querySelector('.close-popup')) {
      document.querySelector('html').classList.remove('active-scroll');
      this.activeElem.classList.remove('--active');

      enableBodyScroll(document.body);
    }
  }

  destroy() {
    this.openPopup.destroy();
    this.ClosePopup.destroy();
    this.closePopupClick.destroy();
  }
}
